module.exports = __webpack_public_path__ + "img/products5.ed04efbb.svg";